import { render, staticRenderFns } from "./ReactionsList.vue?vue&type=template&id=6216fb6a&scoped=true"
import script from "./ReactionsList.vue?vue&type=script&lang=js"
export * from "./ReactionsList.vue?vue&type=script&lang=js"
import style0 from "./ReactionsList.vue?vue&type=style&index=0&id=6216fb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216fb6a",
  null
  
)

export default component.exports